import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {FacebookShareButton, FacebookShareCount, TwitterShareButton, PinterestShareButton} from 'react-share';
import {faFacebookF, faTwitter, faPinterestP} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import './ShareButtons.scss';

export default function ShareButtons(props) {
  return (
    <>
      {props.floating ? (
        <div className="social-share social-share-floating">
          <ShareButtonsList {...props} />
        </div>
      ) : (
        <>
          {props.shareText ? (
            <div className="social-share-copy d-flex align-items-center justify-content-center">
              <div className="social-share-text mb-2 mb-sm-0 mr-sm-2">Share on social:</div>
              <div className="social-share d-flex align-items-center justify-content-center">
                <ShareButtonsList {...props} noDescription />
              </div>
            </div>
          ) : (
            <div className={classNames('social-share d-flex align-items-center', props.alignment)}>
              <ShareButtonsList {...props} noDescription />
            </div>
          )}
        </>
      )}
    </>
  );
}

ShareButtons.defaultProps = {
  alignment: 'justify-content-center justify-content-lg-end'
};

export function ShareButtonsList({
  shareUrl = 'https://brain.foodrevolution.org/masterclass/',
  shareImg = 'https://cdn.foodrevolution.org/hbc/og/hbc-open-graph-20200903-evergreen-masterclass-fbt.jpg',
  facebookDescription = 'Did you know you can protect your brain and boost cognitive performance at any age? Join FRN CEO, Ocean Robbins, and the fabulous The Brain Docs in the FREE Brain Breakthroughs Masterclass and learn the key to lasting brain health and happiness.',
  twitterDescription = 'Healthy brain, happy life! #BrainBreakthroughs Learn how you can protect your brain and boost cognitive performance at any age in the FREE Brain Breakthroughs Masterclass:',
  twitterHashtags = [''],
  pinterestDescription = 'You can protect your brain and boost cognitive performance at any age! In the Brain Breakthroughs Masterclass, FRN CEO, Ocean Robbins, and the fabulous The Brain Docs reveal the top 10 brain breakthroughs to help you create lasting brain health and happiness. Sign up for this FREE masterclass here:',
  pinterestImg = 'https://cdn.foodrevolution.org/hbc/og/hbc-open-graph-20200903-evergreen-masterclass-pinterest.jpg',
  noDescription = false,
  ...props
}) {
  return (
    <>
      {noDescription ? null : (
        <div className="social-button">
          <div className="btn btn-social btn-social-share">Shares</div>
        </div>
      )}

      <FacebookShareButton className="social-button" url={shareUrl} quote={facebookDescription}>
        <div className="btn btn-social btn-social-facebook">
          <FontAwesomeIcon className="social-button-icon" icon={faFacebookF} />
          <span className="btn-social-description btn-social-description-facebook d-none d-md-inline">Facebook</span>
        </div>
      </FacebookShareButton>

      <TwitterShareButton
        className="social-button"
        url={shareUrl}
        via="afoodrevolution"
        hashtags={twitterHashtags}
        title={twitterDescription}
      >
        <div className="btn btn-social btn-social-twitter">
          <FontAwesomeIcon className="social-button-icon" icon={faTwitter} />
          <span className="btn-social-description btn-social-description-twitter d-none d-md-inline">Twitter</span>
        </div>
      </TwitterShareButton>

      <PinterestShareButton
        className="social-button"
        url={shareUrl}
        media={pinterestImg}
        description={pinterestDescription}
      >
        <div className="btn btn-social btn-social-pinterest">
          <FontAwesomeIcon className="social-button-icon" icon={faPinterestP} />
          <span className="btn-social-description btn-social-description-pinterest d-none d-md-inline">Pinterest</span>
        </div>
      </PinterestShareButton>
    </>
  );
}
